export default "__VITE_ASSET__DDsqwv3y__"